export default function formatConditional(value) {
  let formatTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let currencyFormatter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!formatTooltip) return value;
  return currencyFormatter.format(value);
}